import React from "react";
import { Link } from "react-router-dom";

/*eslint-disable */

interface ArticulosComponentProps {
  newsForCategories: any;
}

declare const window: any;
const ArticulosComponent: React.FC<ArticulosComponentProps> = ({
  newsForCategories,
}) => {
  return (
    <div className="articulos">
      {/* H2 - Título de la sección */}
      <h2 className="title">Lee más artículos</h2>
      
      <div className="contenido row justify-content-center">
        <div className="col-lg-6 col-sm-12">
          <Link
            to={`/noticias/${newsForCategories[0]?.category_id}/${newsForCategories[0]?.slug}`}
            className="left"
          >
            <img 
              src={`https://manager.hyundaicolombia.co/${newsForCategories[0]?.media?.url}`} 
              alt={newsForCategories[0]?.title || "Imagen de noticia"} 
            />
            
            {/* H3 - Título de la noticia principal */}
            <h3 className="title">{newsForCategories[0]?.title}</h3>
            
            {/* H4 - Categoría de la noticia */}
            <h4 className="category">{newsForCategories[0]?.category}</h4>
            
            {/* BOTÓN SIN MODIFICAR */}
            <Link
              to={`/noticias/${newsForCategories[0]?.category_id}/${newsForCategories[0]?.slug}`}
              className="readMore"
            >
              Leer más
            </Link>
          </Link>
        </div>
        
        <div className="col-lg-6 col-sm-12">
          <div className="right">
            <div className="noticia row">
              {newsForCategories?.map((item: any, index: number) =>
                index === 0 ? null : (
                  <React.Fragment key={index}>
                    <Link
                      to={`/noticias/${item?.category_id}/${item?.slug}`}
                      className="col-lg-6 col-sm-12 mb-4"
                    >
                      <img 
                        src={`https://manager.hyundaicolombia.co/${item?.media?.url}`} 
                        alt={item?.title || "Imagen de noticia"} 
                      />
                    </Link>
                    
                    <Link
                      to={`/noticias/${item?.category_id}/${item?.slug}`}
                      className="col-lg-6 col-sm-12 mar"
                    >
                      {/* H3 - Título de la noticia secundaria */}
                      <h3 className="title">{item?.title}</h3>
                      
                      {/* H4 - Categoría de la noticia */}
                      <h4 className="category">{item?.category}</h4>
                      
                      {/* BOTÓN SIN MODIFICAR */}
                      <Link
                        to={`/noticias/${item?.category_id}/${item?.slug}`}
                        className="readMore"
                      >
                        Leer más
                      </Link>
                    </Link>
                  </React.Fragment>
                )
              )}
            </div>
          </div>
        </div>
      </div>
      
      {/* BOTÓN SIN MODIFICAR */}
      <Link to={"/noticias"} className="all-news">
        Conoce todos los artículos
      </Link>
    </div>
  );
};

export default ArticulosComponent;